import { getStartTime } from '../../lib/aegis/utils';
import aegis from '../../lib/aegis';
import { elk } from '@tencent/ppd-base-libs';

const LOGIN_NAVIGATE_START = 'before_login_navigationStart';

/**
 * 带登录过程的测速数据上报处理类
 */
export default class LoginReport {
  /** 业务标识 */
  business = '';

  constructor(business: string) {
    if (!business) {
      throw new Error('business is required');
    }
    this.business = business;
  }

  get key() {
    return `${LOGIN_NAVIGATE_START}_${this.business}`;
  }

  /** 获取登录上报数据 */
  public getLoginReportInfo() {
    try {
      const data = this.getCacheTiming();
      const loginDuration = this.getLoginDuration();
      if (data && loginDuration > 0) {
        return {
          loginDuration,
          cacheTiming: data.timing,
        };
      }
    } catch (error) {
    }
    return null;;
  }

  /** 上报登录跳转前页面起始时间：navigationStart */
  public reportStartTiming(pageStart?: number) {
    try {
      const time = {
        navStart: getStartTime(),
        pageStart: pageStart || performance.timing.domLoading || getStartTime(),
        loginBefore: new Date().getTime(),
        timing: performance.timing,
      };
      sessionStorage.setItem(this.key, JSON.stringify(time));
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * 上报测速时长
   * @param firstScreenTiming 首屏渲染时长
   */
  public reportAllTiming(firstScreenTiming: number) {
    try {
      const loginDuration = this.getLoginDuration();
      const beforeLoginTiming = this.getBeforeLoginTimging();
      const checkLoginDuration = this.getCheckLoginDuration();
      const loginPageStartDuration = this.getLoginPageStartDuration();
      const beforeLoginTime = this.getBeforeLoginTime();
      const oauth2Duration = this.getOauth2Duration();
      this.removeLoginNavStartTiming();
      if (loginDuration > 0) {
        // 上报登录跳转花费时间
        aegis.reportTime('loginDuration', loginDuration);
        // 上报登录跳转情况下的首屏渲染总时长
        aegis.reportTime('loginFirstScreenTiming', firstScreenTiming + loginDuration);
        // 上报登录前页面至首次DOM渲染耗时
        aegis.reportTime('loginPageStartDuration', loginPageStartDuration);
        // 获取登录前页面检测登录态耗时数据
        aegis.reportTime('checkLoginDuration', checkLoginDuration);
        // 上报第一次调用登录接口耗时
        aegis.reportTime('promLoginDuration', getStartTime() - beforeLoginTime);
        // 上报oauth2 + 二次prom.login跳转耗时
        aegis.reportTime('oauth2Duration', oauth2Duration);
        elk({
          key: 'pageTiming',
          msg: { beforeLoginTiming, timing: performance.timing },
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  /** 获取登录过程所花费时间间隙 */
  private getLoginDuration() {
    const data = this.getCacheTiming();
    if (data) {
      const { navStart } = data;
      const dutation = getStartTime() - navStart;
      if (navStart > 0 && dutation > 0) {
        return dutation;
      }
    }
    return 0;
  }

  private getOauth2Duration() {
    return performance.timing.fetchStart - getStartTime();
  }

  private getCacheTiming() {
    try {
      const res = sessionStorage.getItem(this.key);
      if (res) {
        return JSON.parse(res) as {
          navStart: number;
          pageStart: number;
          loginBefore: number;
          timing: PerformanceTiming
        };
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  /** 获取登录前页面时间数据 */
  private getBeforeLoginTime() {
    const data = this.getCacheTiming();
    if (data) {
      return data.loginBefore;
    }
    return 0;
  }

  /** 获取登录前页面DOM首次渲染时间数据 */
  private getLoginPageStartDuration() {
    const data = this.getCacheTiming();
    if (data) {
      const { navStart, pageStart } = data;
      const duration = pageStart - navStart;
      if (navStart && pageStart && duration) {
        return duration;
      }
    }
    return 0;
  }

  /** 获取登录前页面检测登录态耗时数据 */
  private getCheckLoginDuration() {
    const data = this.getCacheTiming();
    if (data) {
      const { loginBefore, navStart } = data;
      const duration = loginBefore - navStart;
      if (loginBefore && navStart && duration) {
        return duration;
      }
    }
    return 0;
  }


  /** 获取登录前页面时间数据 */
  private getBeforeLoginTimging() {
    const data = this.getCacheTiming();
    if (data) {
      return data.timing;
    }
    return null;
  }


  /** 删除登录时间记录 */
  private removeLoginNavStartTiming() {
    try {
      sessionStorage.removeItem(this.key);
    } catch (error) {
      console.error(error);
    }
  }
}
